import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import account from '@/locales/da/account.json';
import activities from '@/locales/da/activities.json';
import billing from '@/locales/da/billing.json';
import company from '@/locales/da/company.json';
import dashboard from '@/locales/da/dashboard.json';
import errors from '@/locales/da/errors.json';
import extraction from '@/locales/da/extraction.json';
import gantt from '@/locales/da/gantt.json';
import links from '@/locales/da/links.json';
import notifications from '@/locales/da/notifications.json';
import partnerClaim from '@/locales/da/partnerClaim.json';
import planPdf from '@/locales/da/planPdf.json';
import planning from '@/locales/da/planning.json';
import project from '@/locales/da/project.json';
import reports from '@/locales/da/reports.json';
import settings from '@/locales/da/settings.json';
import signup from '@/locales/da/signup.json';
import task from '@/locales/da/task.json';
import trackers from '@/locales/da/trackers.json';

i18n.use(initReactI18next).init({
  resources: {
    da: {
      account,
      activities,
      billing,
      company,
      dashboard,
      errors,
      extraction,
      gantt,
      trackers,
      planning,
      planPdf,
      project,
      reports,
      notifications,
      task,
      links,
      signup,
      partnerClaim,
      settings,
    },
  },
  ns: [
    'activities',
    'dashboard',
    'errors',
    'extraction',
    'gantt',
    'trackers',
    'planning',
    'planPdf',
    'project',
    'reports',
    'account',
    'billing',
    'company',
    'links',
    'task',
    'notifications',
    'signup',
    'partnerClaim',
    'settings',
  ],
  lng: 'da',
  fallbackLng: 'da',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
